<mdk-btn
    [autoWidth]="true"
    [customPadding]="buttonText ? '' : '0px 3px 0px 11px'"
    [buttonText]="buttonText" 
    [buttonSrc]="buttonIconSrc" 
    (buttonClick)="buttonClick()" 
/>
